import * as React from "react";
import {ClientReport} from "../../model/ClientReport.model";
import {SharedDocumentApi} from "../../api/SharedDocumentApi";
import {getFileExtension} from "../../utils/fileUtil";
import {formatLongDate} from "../../utils/dateUtil";

export interface IDocumentReportCardProps {
    report: ClientReport;
}

export const DocumentReportCard: React.FunctionComponent<IDocumentReportCardProps> = ({report}) => {
    const primaryDocument = report.documents.find((d) => d.isPrimary);

    if (!primaryDocument) {
        return null;
    }

    const fileExtension = getFileExtension(primaryDocument.fileName).toUpperCase();

    const handleOpenReport = () => {
        SharedDocumentApi.getDocumentDownload(primaryDocument.id, primaryDocument.fileName, true);
    };

    return (
        <div className="document-report-card" data-testid="document-report-card">
            <div className="document-report-card__file-icon">
                <i className={`fa-solid fa-file-${fileExtension === "PDF" ? "pdf" : "ppt"} document-report-card__icon`}
                   aria-hidden="true"/>
                <span className="document-report-card__file-type">{fileExtension}</span>
            </div>
            <button
                type="button"
                className="document-report-card__open-button"
                data-testid="document-report-card__open-button"
                onClick={handleOpenReport}
            >
                Open Report
            </button>
            <span className="document-report-card__published-date" data-testid="document-report-card__published-date">
                Published {formatLongDate(report.date)}
            </span>
        </div>
    );
};
